import { Typography } from '@mui/material';
import React from 'react';
import type { RegistryEntityContact } from '../../api/registryEntityTypes';
import { CONTACT_ROLE_LABELS, representativeLabel } from '../../entities/entityFormat';
import DataTable from '../../ui/DataTable';
import { SectionCard, StatusChip } from '../../ui/primitives';

/** The entity's linked platform contacts with their real role. Only Owners act for the entity. */
export default function EntityContactsCard({ contacts }: { contacts: RegistryEntityContact[] }) {
  return (
    <SectionCard
      title={`Linked contacts (${contacts.length})`}
      subtitle="Owners act for the entity. Representatives (directors, trustees, advisers, family) can view only."
      noPadding
    >
      <DataTable
        rows={contacts}
        rowKey={(row) => `${row.role}-${row.externalId}`}
        dense
        emptyMessage="No contacts are linked to this entity"
        columns={[
          {
            key: 'name',
            label: 'Contact',
            render: (row) => (
              <>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {row.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {row.email ?? '—'}
                </Typography>
              </>
            ),
          },
          {
            key: 'role',
            label: 'Role',
            render: (row) => (
              <StatusChip
                status={row.role === 'OWNER' ? 'VERIFIED' : 'PENDING'}
                tone={row.role === 'OWNER' ? 'success' : 'neutral'}
                label={CONTACT_ROLE_LABELS[row.role]}
              />
            ),
          },
          {
            key: 'kind',
            label: 'Representative type',
            hideBelow: 'sm',
            render: (row) => representativeLabel(row) ?? '—',
          },
        ]}
      />
    </SectionCard>
  );
}
